module.exports = __webpack_public_path__ + "static/media/git.444acf17.jpeg";